import React from 'react';

const SubscriptionCancel = () => {
  const navigateToDashboard = () => {
    window.location.href = '/dashboard';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        {/* Cancel Icon */}
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        {/* Cancel Message */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Subscription Canceled
        </h2>
        
        <p className="text-gray-600 mb-6">
          You canceled the subscription process. No payment has been made and you can try again anytime.
        </p>

        {/* What they're missing */}
        <div className="bg-blue-50 rounded-xl p-4 mb-6">
          <h3 className="font-semibold text-blue-900 mb-3">What you're missing:</h3>
          <div className="space-y-2 text-left">
            <div className="flex items-center text-sm text-blue-800">
              <svg className="w-4 h-4 text-blue-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v3m0-3h3m-3 0h-3" />
              </svg>
              Full access to Learning Paths
            </div>
            <div className="flex items-center text-sm text-blue-800">
              <svg className="w-4 h-4 text-blue-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v3m0-3h3m-3 0h-3" />
              </svg>
              Unlimited Practice Sessions
            </div>
            <div className="flex items-center text-sm text-blue-800">
              <svg className="w-4 h-4 text-blue-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v3m0-3h3m-3 0h-3" />
              </svg>
              Progress tracking & analytics
            </div>
            <div className="flex items-center text-sm text-blue-800">
              <svg className="w-4 h-4 text-blue-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m0 0v3m0-3h3m-3 0h-3" />
              </svg>
              Gamification & achievements
            </div>
          </div>
        </div>

        {/* Reminder of the offer */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <div className="text-center">
            <div className="text-lg font-bold text-green-600 mb-1">
              $10<span className="text-sm text-green-500">/month</span>
            </div>
            <div className="text-sm text-green-600">
              14-day free trial • Cancel anytime
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={navigateToDashboard}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
          >
            Try Again Later
          </button>
          
          <button
            onClick={navigateToDashboard}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-lg transition-colors duration-200"
          >
            Back to Dashboard
          </button>
        </div>

        {/* Encouragement */}
        <div className="mt-6 pt-4 border-t border-gray-100">
          <p className="text-sm text-gray-600">
            Questions? We're here to help! Contact support if you need assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;